<template>
  <v-card
    class="mb-3 px-2 py-3 transparent-border"
    color="alert shadow-alert"
    tile
    role="alert"
  >
    <div
      class="d-flex flex-grow"
      :class="{
        'justify-center': center
      }"
    >
      <div
        class="px-3"
        data-test="alertIcon"
        style="justify-content: center; text-align: right"
      >
        <v-icon color="red">{{ icon }}</v-icon>
      </div>
      <div
        :style="`align-self: center; max-width: ${maxWidth}`"
        data-test="alertContent"
      >
        <slot>
          <div class="alert-remove-paragraph-margin" v-html="text" />
        </slot>
      </div>
      <div v-if="closable" data-test="alertClose">
        <v-icon
          :small="$vuetify.breakpoint.smAndDown"
          :style="!$vuetify.breakpoint.smAndDown ? 'margin:auto;' : ''"
          >$iconTimesCircle</v-icon
        >
      </div>
    </div>

    <slot name="lists" />
  </v-card>
</template>
<script>
export default {
  name: "AppAlertNotice",
  props: {
    icon: {
      type: String,
      default: "$iconBell"
    },
    closable: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: "45em"
    }
  }
};
</script>
<style lang="scss">
.alert-remove-paragraph-margin p {
  margin-bottom: 0 !important;
}
</style>
<style scoped>
.shadow-alert {
  box-shadow: outset 0 -1px 0 0 #d0021b !important;
  z-index: 1;
}
</style>
